import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { BtnClickComponent } from 'src/app/_shared/bloque-buttons/btn-click/btn-click.component';

@Component({
  selector: 'app-banner-venture-drimer',
  standalone: true,
  imports: [
    BtnClickComponent
  ],
  templateUrl: './banner-venture-drimer.component.html',
  styleUrl: './banner-venture-drimer.component.scss'
})
export class BannerVentureDrimerComponent {
  @Input() plataformaId: string;
  @Input() domainUrl: string;
  @Input() domainVentureUrl: string;

  private readonly slug: string = '/drimer';
  private readonly window: Window;

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private _usuarioService: UsuarioService,
    private _router: Router
  )
  {
    if (isPlatformBrowser(this._platformId))
    {
      this.window = window;
    }
  }

  public enviarEventoClick(): void
  {
    if (isPlatformBrowser(this._platformId))
    {
      const userSesionData = this._usuarioService.getSession();
      const isLogged = userSesionData ? true : false;
      const textoBanner = document.getElementById("banner-drimer-pretitle").textContent;
      const userId = isLogged ? userSesionData.userId : 0;
      const datalayer = this.window['dataLayer'] || [];
      datalayer.push({
        'event': 'banner_click',
        'userId': userId,
        'textBanner': textoBanner,
        'nombrebanner': 'banner_drimer'
      });
      if (this.plataformaId === "VENTURE")
      {
        this._router.navigateByUrl(this.slug);
      } else
      {
        this.window.location = this.domainVentureUrl + this.slug;
      }
    }
  }
}
